import React, { useState, useEffect } from 'react';
import config from '../../config';

const About = () => {

	const [aboutData, setAboutData] = useState([]);

	useEffect(() => {
	    const fetchAbout = async () => {
	      try {
	        const response = await fetch(`${config.apiUrl}/about`);
	        const about = await response.json();
	        setAboutData(about);
	      } catch (error) {
	        console.error('Error fetching about', error);
	      }
	    };
	    fetchAbout();
	  }, []);

	return (
		<div style={{ padding: '0%, 8%', maxWidth: '800px' }}>
            {aboutData.length ? (
            	aboutData[0].content.map((block, index) => {
            	switch(block.type) {
                	case 'paragraph':
                		return <p key={index}>{block.text}</p>;
                	case 'subheading':
                		return <h2 key={index}>{block.text}</h2>;
                	case 'unorderedlist':
                		return (
                			<ul key={index}>
                				{block.items.map((item, itemIndex) => (
                					<li key={itemIndex}>{item}</li>
                				))}
                			</ul>);
                	case 'orderedlist':
                		return (
                			<ol key={index}>
                				{block.items.map((item, itemIndex) => (
                					<li key={itemIndex}>{item}</li>
                				))}
                			</ol>);
                	case 'image':
                		return <img key={index} src={block.url} alt={block.alt} />;
                    default:
                        return <p key={index}>{block.text}</p>;
                }})
            	) : (
            		<h2>Loading...</h2>)
            }
		</div>
	)
}

export default About;